module.exports = __webpack_public_path__ + "img/selma-logo.cc79b613.jpg";